// by convention, composable function names start with "use"
export function useFormatDate(date) {
  const year = date.substring(0, 4);
  const month = date.substring(5, 7);
  const day = date.substring(8, 10);
  // expose managed state as return value
  return `${day}/${month}/${year}`;
}
export function useFormatDateDMY(date) {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  // expose managed state as return value
  return `${day}-${month}-${year}`;
}
export function useFormatDateYMD(dateString) {
  const day = dateString.substring(0, 2);
  const month = dateString.substring(3, 5);
  const year = dateString.substring(6, dateString.length);
  // expose managed state as return value
  return `${year}/${month}/${day}`;
}

export function useFormatDateYMDPersoneList(dateString) {
  const day = dateString.substring(0, 2);
  const month = dateString.substring(3, 5);
  const year = dateString.substring(6, dateString.length);
  // expose managed state as return value
  return `${year}-${month}-${day}`;
}

export function format(date) {
  const day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
  const month =
    date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}
export function formatDateTime(date) {
  const day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
  const month =
    date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
  const year = date.getFullYear();

  return `${day}/${month}/${year} ${date
    .getHours()
    .toString()
    .padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
}
export function fromUTCtoISODate(date) {
  const day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
  const month =
    date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
}

export function fromUTCtoISODateDMY(date) {
  const day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
  const month =
    date.getMonth() + 1 > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

export function formattedDateTime(date) {
  const d = new Date(date);
  const formatted = `${d.getDate().toString().padStart(2, "0")}/${(
    d.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}/${d.getFullYear()}`;
  return formatted;
}

export function toIsoLocalTimestamp(date) {
  if (!date) return null;
  const d = new Date(date);
  const pad = (n) => n.toString().padStart(2, "0");
  const ms = d.getMilliseconds().toString().padStart(3, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.${ms}`;
}

export const NOW = new Date();
export const getDateFromISOFormat = (ISODate) => {
  if (!ISODate) return null;
  return new Date(ISODate);
};
export const blockElementByDate = (startDate, endDate = null) => {
  if (!startDate) {
    return false;
  }

  const start = new Date(startDate);
  if (Number.isNaN(start.getTime())) {
    return false;
  }

  if (!endDate) {
    return NOW >= start;
  }

  const end = new Date(endDate);
  if (Number.isNaN(end.getTime())) {
    return NOW >= start;
  }

  return NOW >= start && NOW <= end;
};

export const toMidnightISOString = (value) => {
  if (!value) {
    return value;
  }
  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) {
    return value;
  }

  const year = parsedDate.getFullYear();
  const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
  const day = String(parsedDate.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}T00:00:00.000Z`;
};
export function verificaFormatoData(dataString) {
  var formatoData = /^\d{2}\/\d{2}\/\d{4}$/;
  if (formatoData.test(dataString)) {
    return useFormatDateYMD(dataString); // La stringa corrisponde al formato desiderato
  } else {
    return null; // La stringa non corrisponde al formato desiderato
  }
}
